import variables from '@/styles/variables.module.scss';

/** MSW 활성화 여부 */
export const isMswOn = false;

export const isServer = typeof window === 'undefined';

export const mobileMediaQuery = `@media (max-width: ${variables.mobile})`;
